import { render } from "./relatedContactTable.vue?vue&type=template&id=4460258a&ts=true"
import script from "./relatedContactTable.vue?vue&type=script&lang=ts"
export * from "./relatedContactTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__